// import { trackOrganizationSubmitted } from '@services/mixpanel/trackers/UserSessionMetrics';
import slugify from 'slugify';
import * as yup from 'yup';
import { OrgFormSchema, OrgStates } from '../Organization.types';

export const initialFormState: OrgFormSchema = {
  email: '',
};

export const schema = yup
  .object({
    email: yup.string().required(),
  })
  .required();
export type SubmitWithHookArgs = [
  setOrgFormState: SetState<OrgStates>,
  failureCount: number,
  refetch: VoidFunction,
];
export function submitWithHook(...args: SubmitWithHookArgs) {
  const [setOrgFormState, failureCount, refetch] = args;
  function onSubmit(form: OrgFormSchema) {
    const { email } = form;

    // trackOrganizationSubmitted(email);

    const slug = slugify(email, {
      lower: true,
    });
    if (slug === 'admin') return setOrgFormState('malicious');
    // Mutate start point
    initialFormState.email = form.email;
    setOrgFormState('submitted');
    if (failureCount > 0) refetch();
    return null;
  }
  return onSubmit;
}

export type SetState<T> = React.Dispatch<React.SetStateAction<T>>;
